import React, { useEffect, useState } from "react";
import MasterLayout from "../masterLayout/MasterLayout";
import Breadcrumb from "../components/Breadcrumb";
import AppointmentTable from "../components/AppointmentTable";
import { useParams } from "react-router-dom";
import ViewAppointmentLayer from "../components/ViewAppointmentLayer";
import ViewStockLayer from "../components/ViewStockLayer";
import { API_URL } from "..";
import ViewSupplierLayer from "../components/ViewSupplierLayer";

const ViewSupplierPage = () => {
    const [data,setData]= useState({})
    const {id} = useParams();
    const fetchAppointments = async () => {
        let headerList = {
          "Accept": "*/*",
          "Content-type": "application/json",
        };
        const response = await fetch(
          API_URL+`/api/suppliers/${id}`,
          { method: "GET", headers: headerList }
        );
        const data = await response.json();
        if (response.status === 200) {
            setData(data.supplier)
        }
      };

      useEffect(()=>{
        fetchAppointments()
      },[1])
  return (
    <>

      {/* MasterLayout */}
      <MasterLayout>

        {/* Breadcrumb */}
        <Breadcrumb title="View Supplier" />
        {
            // data.title === undefined ? 
            // null:
            <ViewSupplierLayer data={data}/>
        }
        
      </MasterLayout>

    </>
  );
};

export default ViewSupplierPage; 
